import type { TutorialStep } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";

import Tutorial from "~/components/Tutorial";
import { useAccess } from "~/hooks";

const CertificationTutorial = () => {
	const { isMember } = useAccess();
	const { isLoaded } = useAuth();

	const steps: TutorialStep[] = [
		{
			content:
				"Welcome to your certification dashboard. Let's get you started!",
			target: "#certification-title",
			disableScrolling: true,
		},
		{
			content:
				"Choose a certification you'd like to work towards achieving. You can change this at any time.",
			target: "#certification-select",
		},
		{
			content:
				"Your progress will be shown here. As you complete courses, you will earn credits.",
			target: "#certification-progress",
		},

		{
			content:
				"The categories are already in the order recommended for progression through the certification; however, you can complete courses in any order.",
			target: "#certification-catalogue",
		},

		{
			content:
				"Your goal is to achieve the required number of credits for each of these categories. You achieve credits by passing a final exam for a course.",
			target: ".certification-catalogue-item-credits",
		},

		{
			content:
				"Choose a course category to see all courses available for that category.",
			target: ".certification-catalogue-item",
		},

		{
			content:
				"Electives can be chosen from additional courses in a category (beyond required credits), or courses in additional categories not included in the selected certification.",
			target: ".certification-catalogue-electives",
		},

		{
			content:
				"Use this button to select a certification as your default homepage.",
			target: ".certification-select-btn",
		},

		isMember
			? {
					content: "Take your first course to start earning credits!",
					target: "#next-recommended-course",
				}
			: {
					content: "Become a member today to start earning credits!",
					target: "#upgrade-banner",
				},
	];

	if (!isLoaded) return null;

	return (
		<Tutorial
			steps={steps}
			tutorialKey="certificationTutorial"
			trackingEventTitle="Certification Tutorial"
		/>
	);
};

export default CertificationTutorial;
